module.exports = __webpack_public_path__ + "static/media/team-introduction-9.35628d47.jpg";